import { css } from '@emotion/react';

export const multiDropdownStyle = css`
    font-family: var(--body-fontFamily);
    font-size: var(--body-fontSize);
    font-weight: var(--body-fontWeight);

    .dropdown {
        display: flex;
        margin-top: 0.5rem;

        .dropdown-toggle {
            width: 10rem;
            height: 2.75em;
            padding: 0 0.5rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border: 1px solid var(--color-dropdown-border);
            color: var(--color-text-primary);

            .dropdown-toggle-icon {
                margin: 0.5rem;
                color: var(--color-primary);
            }

            .placeholder {
                color: var(--color-placeholder);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .dropdown-menu {
            display: none;
        }

        .dropdown-menu.show {
            display: flex;
            flex-direction: column;
            position: absolute;
            z-index: 1000;
            width: 10rem;
            max-height: 10rem;
            overflow-y: auto;
            margin: 0;
            font-size: var(--font-size-regular);
            color: $color-primary;
            font-weight: normal;
            text-align: left;
            list-style: none;
            background-color: var(--color-white);
            background-clip: padding-box;
            border: 1px solid rgba(0, 0, 0, 0.175);
            border-radius: 0.375rem;

            &::-webkit-scrollbar {
                width: 5px;
                height: 5px;
            }

            &::-webkit-scrollbar-track {
                background: var(--color-white);
            }

            &::-webkit-scrollbar-thumb {
                background: var(--color-grey);
                border-radius: 5px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: var(--color-grey);
            }
        }

        .dropdown-item {
            display: flex;
            justify-content: space-between;

            .dropdown-item-label {
                cursor: pointer;
            }
        }
    }

    .dropdown-search-input {
        outline: 0;
        width: 100%;
        padding: 0;
        border: 0;

        &::placeholder {
            color: var(--primary-contrastText);
        }
    }

    .no-option-found {
        color: var(--primary-contrastText);
    }

    .no-data-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

export default multiDropdownStyle;
